angular.module('impactx.search').controller('MetaProductGroupCtrl', [
    '$scope',
    'dataGen',
    'ToolbarService',
    '$routeParams',
    MetaProductGroupCtrl
]);

function MetaProductGroupCtrl($scope, dataGen, ToolbarService, $routeParams) {
    ToolbarService.setButtons([]);
    dataGen.getData($scope, {prgId: $routeParams.prgId}, "/search/metaprg");
}